"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envConfig = exports.ENV_BUILD_CONFIGS = void 0;
const _1 = require(".");
/**
 * A list of environment variables that were requested at build time. Used by webpack to
 * capture build-time environment variables values.
 */
exports.ENV_BUILD_CONFIGS = [];
/**
 * Returns an environment variable from the process environment. Depending on the `type` in the
 * call to get the variable, the variable's value may be what it was at build time, not at runtime.
 * The return value is not the variable value itself, but rather a provider that has to be called
 * to read the variable value (meaning, this is safe to call even if the variable doesn't exist,
 * because someone else later needs to call the provider to get the value -- that call may explode,
 * but this one won't).
 *
 * @param name The name of the environment variable to retrieve.
 * @param type The mode for accessing the variable. Defaults to `'build'`, i.e. getting the
 * variable as it was set at build time (webpack is connected here to make this possible). This
 * argument can also be `'runtime'` in which case the value at build time is ignored and the
 * variable is pulled live from `process.env`.
 * @param [defaultValue] The default value to use if the variable is not found.
 *
 * @example const config = { configValue: envConfig('environment_variable_name') };
 */
const envConfig = (name, type = 'build', defaultValue) => {
    if (type === 'build') {
        exports.ENV_BUILD_CONFIGS.push(name);
    }
    return () => {
        /*global __PROCESS_ENV*/
        // @ts-ignore - hack to get around the way webpack/define works
        // - https://github.com/webpack/webpack/issues/14800
        // - https://github.com/webpack/webpack/issues/5392
        const envs = { ...process.env, ...(typeof __PROCESS_ENV !== 'undefined' ? __PROCESS_ENV : {}) };
        if (envs[name] === undefined) {
            if (defaultValue === undefined) {
                throw new Error(`expected to find environment variable with name: ${name}`);
            }
            else {
                return (0, _1.resolveConfigValue)(defaultValue);
            }
        }
        else {
            return envs[name];
        }
    };
};
exports.envConfig = envConfig;
